define('lib/Podio.Logger',['require','underscore','lib/Podio.Config'],function(require) {

  var _ = require('underscore');
  var podioConfig = require('lib/Podio.Config');

  function log() {
    var args = _.toArray(arguments);

    if (!_.include(['development', 'staging'], podioConfig.environment)) {
      return false;
    }

    if (window.console && window.console.log) {  /* IE 9 race condition check */
      if (window.console.log.apply) {            /* IE 9 doesn't have apply */
        window.console.log.apply(window.console, args);
      } else {
        _.each(args, function(arg) {
          window.console.log(arg);
        });
      }
    }
  }

  return {
    log: log
  };

});

